import { useEffect, useState } from 'react'

import { getLeadNoteById } from '../api'
import { LeadNote } from '@user/components/Notes/typings'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetLeadNoteOnMount = (noteId: number) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )
  const [note, setNote] = useState<LeadNote | null>(null)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getLeadNoteById(noteId))

        if (mounted) {
          if (getLeadNoteById.fulfilled.match(result)) {
            setNote(result.payload)
            setStatus('success')
          } else {
            toast.error('Error loading note.')
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, noteId])

  return [status, note] as const
}
